import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import './index.css';

const redirectUri = process.env.NODE_ENV === 'production'
  ? 'https://compute.ocklet.com/auth/callback'
  : 'http://localhost:3000/auth/callback';

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_B0vAnqjIf",
  client_id: "1ep6l8f3vq2bmasp6okpgat5sp",
  redirect_uri: redirectUri, // This URI now matches a route
  response_type: "code",
  scope: "email openid phone",
  automaticSilentRenew: true,
  loadUserInfo: true,
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/* Wrap the AuthProvider and App with BrowserRouter */}
    <BrowserRouter>
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);